angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/panels/panels.tpl.html',
    '<div id="panels-container" ng-controller="PanelsCtrl">\n' +
    '</div>\n' +
    '');
}]);
